LocationTrackingService = ($rootScope, $location) ->
  locationHistories = ['/']

  saveLocation: ->
    currentLocation = $location.path()
    locationHistories.push currentLocation
    locationHistories.shift() if locationHistories.length > 2

  currentLocation: ->
    locationHistories?[1] || locationHistories[0]

  previousLocation: ->
    locationHistories[0]

LocationTrackingService.$inject = ["$rootScope", "$location"]

module.exports = LocationTrackingService


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/location-tracking/location-tracking-service.coffee